export default "__VITE_ASSET__189d5fee__"